// extracted by mini-css-extract-plugin
module.exports = {"HeaderTitle":"HeaderTitle_HeaderTitle__6iSke","left":"HeaderTitle_left__2ifKl","center":"HeaderTitle_center__2-Caz","divider":"HeaderTitle_divider__3Spbh"};